<template>
  <app-multiselect
    :singleSelect="true"
    :options="innerOptions"
    :value="innerValue" 
    @input="onInput"
    :multiple="false"
    :disabled="disabled"
    :searchable="searchable"
    :readonly="readonly"
    :small="small"
    :allowEmpty="allowEmpty"
    :placeholder="placeholder"
    :searchPlaceholder="searchPlaceholder"
    @change="onChange"
    :required="required"
    @open="onOpen"
    @search-change="onSearchChange"
    :loading="loading"
    :forceSingleLine="forceSingleLine"
    :openDirection="openDirection"
  >
    <!-- Pass scoped slots through -->
    <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
    <!-- Pass slots through -->
    <template v-for="(_, slot) in $slots" :slot="slot">
      <slot :name="slot" />
    </template>
  </app-multiselect>
</template>
<script lang="ts">
import { Component, Prop, Watch } from "vue-property-decorator";
import AppMultiselect from "../app-multiselect/app-multiselect.vue";
import { MultiselectOption, MultiselectOptionId } from "../app-multiselect/types";
import { BaseComponent } from "../base-component/base-component";

@Component({
  name: "app-select",
  components: {
    AppMultiselect,
  }
})
export default class AppSelect extends BaseComponent {
  @Prop({ default: null }) value!: MultiselectOptionId | null;
  @Prop({ default: null }) options!: (MultiselectOption | MultiselectOptionId)[] | null;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: true }) allowEmpty!: boolean;
  @Prop({ default: false }) small!: boolean;
  @Prop({ default: false }) searchable!: boolean;
  @Prop({ default: "" }) placeholder!: string;
  @Prop({ default: "" }) searchPlaceholder!: string;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: false }) forceSingleLine!: boolean;
  @Prop({ default: "" }) openDirection!: string;

  innerValue: string | number | null = null;
  innerOptions: MultiselectOption<MultiselectOptionId>[] = [];

  created() {
    this.innerValue = this.value;
    this.convertOptions();
  }

  @Watch('options') onOptionsChanged() {
    this.convertOptions();
  }

  @Watch('value') onValueChanged() {
    this.innerValue = this.value;
  }

  onInput(value: string | number) {
    this.innerValue = value;

    this.$emit("input", this.innerValue);
  }

  onChange() {
    this.$emit("change", this.innerValue);
  }

  onOpen() {
    this.$emit("open");
  }

  onSearchChange(query: string) {
    this.$emit("search-change", query);
  }

  private convertOptions() {
    this.innerOptions = this.options?.map(o => typeof o === "string" || typeof o === "number" ? { id: o, label: o.toString() } : o) || [];
  }
}
</script>

<style lang="scss">
</style>
